module.exports = __webpack_public_path__ + "img/en.17658624.png";